export const getGreeting = (name: string) => {
  const hours = new Date().getHours();
  let greetingTime;

  if (hours < 12) {
    greetingTime = 'Good morning';
  } else if (hours < 18) {
    greetingTime = 'Good afternoon';
  } else {
    greetingTime = 'Good evening';
  }

  // Extract only the first name
  const firstName = name.split(' ')[0] || '';

  return firstName ? `${greetingTime}, ${firstName}` : greetingTime;
};
